import type React from 'react';
import type { ReactNode } from 'react';
import Header from './Header';

interface LayoutProps {
	children: ReactNode;
}

const Layout = ({ children }: LayoutProps): React.JSX.Element => {
	return (
		<div
			className="flex flex-col min-h-screen"
			style={{ backgroundColor: 'var(--body-bg-alt, #f9f9f9)' }}
		>
			<Header />
			<main className="flex-1 flex flex-col">{children}</main>
		</div>
	);
};

export default Layout;
